import { render, staticRenderFns } from "./TestOne.vue?vue&type=template&id=73c55ba8&scoped=true&"
import script from "./TestOne.vue?vue&type=script&lang=js&"
export * from "./TestOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c55ba8",
  null
  
)

export default component.exports